import { createContext, useContext, useEffect, useState } from "react";
import { DEFAULT_PRICING } from "@/data/site";
import { getPricing } from "@/lib/api";

const PricingContext = createContext(DEFAULT_PRICING);
export const usePricing = () => useContext(PricingContext);

export function PricingProvider({ children }) {
  const [pricing, setPricing] = useState(DEFAULT_PRICING);

  useEffect(() => {
    let active = true;
    getPricing()
      .then((p) => { if (active && p && Array.isArray(p.price_table)) setPricing(p); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  return <PricingContext.Provider value={pricing}>{children}</PricingContext.Provider>;
}
